import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X, ZoomIn, ZoomOut } from "lucide-react";

export const CERT_IMG = "/certificato-gbt.webp";
export const CERT_THUMB = "/certificato-gbt-thumb.webp";
const ALT = "Certificato GBT originale del Dott. Nicola Mauro, rilasciato da Swiss Dental Academy, Bologna 31/07/2024";

export const CertificateLightbox = ({ open, onClose, src = CERT_IMG, alt = ALT, label = "Certificato GBT", tid = "gbt-cert" }) => {
  const [zoom, setZoom] = useState(false);

  useEffect(() => {
    if (!open) return setZoom(false);
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    window.__lenis?.stop();
    return () => { window.removeEventListener("keydown", onKey); window.__lenis?.start(); };
  }, [open, onClose]);

  return createPortal(
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[80] bg-[#0F2317]/90 backdrop-blur-xl" role="dialog" aria-modal="true" aria-label={label}
          onClick={onClose} data-testid={`${tid}-lightbox`}
        >
          <div className="absolute top-5 right-5 z-10 flex gap-2">
            <button onClick={(e) => { e.stopPropagation(); setZoom((z) => !z); }} data-testid={`${tid}-zoom-btn`}
              className="grid place-items-center w-12 h-12 rounded-full bg-[#FCFBF7]/10 text-[#FCFBF7] hover:bg-[#FCFBF7]/20 transition-colors" aria-label={zoom ? "Riduci" : "Ingrandisci"}>
              {zoom ? <ZoomOut size={18} /> : <ZoomIn size={18} />}
            </button>
            <button onClick={onClose} data-testid={`${tid}-close-btn`}
              className="grid place-items-center w-12 h-12 rounded-full bg-[#86C89B] text-[#0F2317] hover:bg-[#FCFBF7] transition-colors" aria-label="Chiudi">
              <X size={18} />
            </button>
          </div>
          <div data-lenis-prevent className={`h-full w-full overflow-auto ${zoom ? "" : "grid place-items-center p-6 sm:p-12"}`}>
            <motion.img
              src={src} alt={alt} data-testid={`${tid}-full-image`}
              initial={{ scale: 0.92, y: 20 }} animate={{ scale: 1, y: 0 }} transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              onClick={(e) => { e.stopPropagation(); setZoom((z) => !z); }}
              className={`rounded-lg bg-white shadow-2xl ${zoom ? "max-w-none w-[200%] sm:w-[1400px] mx-auto my-6 cursor-zoom-out" : "max-h-[88vh] w-auto max-w-full cursor-zoom-in"}`}
            />
          </div>
          <p className="pointer-events-none absolute bottom-5 inset-x-0 text-center text-xs text-[#FCFBF7]/60">
            {zoom ? "Scorri per esplorare · tocca per ridurre" : "Tocca l'immagine per ingrandire"}
          </p>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body,
  );
};
